import MissingPlotLocationModal from './MissingPlotLocationModal';

export default MissingPlotLocationModal;
